import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { PostDriverPenaltyEntity } from '../../domain/entities/PostDriverPenaltyEntity'

export class PostDriverPenaltyModel extends PostDriverPenaltyEntity {
  driverId?: number

  constructor(dataDto: PostDriverPenaltyEntity) {
    super()
    mapEntityProperties<PostDriverPenaltyModel>(this, dataDto, {
      exclude: ['driver'],
      map: {
        driverId: dataDto.driver?.id,
        detectedAt: formatDateTime(dataDto.detectedAt),
        effectiveFrom: formatDateTime(dataDto.effectiveFrom),
        effectiveTo: formatDateTime(dataDto.effectiveTo)
      }
    })
  }
}

function formatDateTime(value?: Date | string | null) {
  if (!value) return undefined
  return new Date(value).toISOString()
}
